import { collection, addDoc, query, where, getDocs, serverTimestamp } from 'firebase/firestore'
import { signInAnonymously } from 'firebase/auth'
import { db, auth } from '@/config/firebase'

interface WaitlistSignup {
  id?: string
  email: string
  timestamp: any // Firestore timestamp
  source?: string
}

export const waitlistService = {
  signup: async (email: string): Promise<{ success: boolean; message?: string }> => {
    try {
      // Ensure user is signed in (anonymously if needed) for Firestore access
      if (!auth.currentUser) {
        await signInAnonymously(auth)
      }
      
      // Check if email already exists in Firestore
      const waitlistRef = collection(db, 'waitlist')
      const emailQuery = query(waitlistRef, where('email', '==', email.toLowerCase()))
      const existingSignup = await getDocs(emailQuery)
      
      if (!existingSignup.empty) {
        return { success: false, message: 'You\'re already on our waitlist!' }
      }
      
      // Add new signup to Firestore
      await addDoc(waitlistRef, {
        email: email.toLowerCase(),
        timestamp: serverTimestamp(),
        source: 'landing_page'
      })
      
      console.log('Waitlist signup:', email)
      return { success: true }
    } catch (error) {
      console.error('Waitlist signup error:', error)
      return { success: false, message: 'Something went wrong. Please try again.' }
    }
  },

  // Optional: Get signups for admin purposes
  getSignups: async (): Promise<WaitlistSignup[]> => {
    try {
      const waitlistRef = collection(db, 'waitlist')
      const snapshot = await getDocs(waitlistRef)
      
      return snapshot.docs.map(doc => {
        const data = doc.data()
        return {
          id: doc.id,
          email: data.email,
          timestamp: data.timestamp,
          source: data.source
        } as WaitlistSignup
      })
    } catch (error) {
      console.error('Error fetching waitlist:', error)
      return []
    }
  }
}